import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { trackCTAClick } from "@/lib/analytics";

export const Differentiation = () => (
    <section
        data-testid="differentiation-section"
        className="bg-[#0B1F44] py-24 lg:py-32"
    >
        <div className="mx-auto max-w-4xl px-6 text-center lg:px-8">
            <Reveal>
                <h2 className="text-3xl font-bold tracking-tight text-white lg:text-4xl">
                    Not another chatbot.{" "}
                    <span className="text-[#60A5FA]">Not another dashboard.</span>
                </h2>
                <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-[#C7D2E8] lg:text-lg">
                    FlowPilot connects marketing activity to commercial
                    outcomes. It does not stop at clicks, impressions or lead
                    capture. It is designed to help businesses understand which
                    activity creates qualified demand and where money should be
                    reinvested.
                </p>
                <a
                    href="#growth-review"
                    data-testid="differentiation-cta"
                    onClick={() => trackCTAClick("differentiation")}
                    className="mt-10 inline-flex items-center justify-center gap-2 rounded-full bg-white px-7 py-3.5 text-base font-semibold text-[#0B1F44] transition-all hover:bg-[#E5E7EB]"
                >
                    Book a 20-minute Growth Review
                    <ArrowRight className="h-4 w-4" />
                </a>
            </Reveal>
        </div>
    </section>
);
